import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

export const AGB = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {/* Back Button */}
        <Button
          onClick={() => navigate('/')}
          variant="outline"
          className="mb-8 border-2 border-black hover:bg-black hover:text-white"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Button>

        {/* Header */}
        <div className="mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold text-black mb-4">Allgemeine Geschäftsbedingungen (AGB)</h1>
          <div className="w-24 h-1 bg-gradient-to-r from-black to-[#00CCDD]"></div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 space-y-8">
          
          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§1 Geltungsbereich</h2>
            <p className="text-gray-700 leading-relaxed">
              Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge, Leistungen und Angebote der THS Bauprojekte GmbH, sofern nichts anderes schriftlich vereinbart wurde.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§2 Angebote und Vertragsschluss</h2>
            <p className="text-gray-700 leading-relaxed">
              Unsere Angebote sind freibleibend. Ein Vertrag kommt erst durch schriftliche Auftragsbestätigung oder Beginn der Arbeiten zustande.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§3 Leistungsumfang</h2>
            <p className="text-gray-700 leading-relaxed">
              Der Umfang der Leistung ergibt sich aus dem jeweiligen Angebot bzw. Vertrag. Änderungen oder Zusatzleistungen bedürfen der schriftlichen Vereinbarung.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§4 Preise und Zahlung</h2>
            <p className="text-gray-700 leading-relaxed">
              Alle Preise verstehen sich netto zzgl. der gesetzlichen Mehrwertsteuer.
              Zahlungen sind ohne Abzug innerhalb der vereinbarten Frist zu leisten. Abschlagszahlungen können vereinbart werden.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§5 Ausführung und Termine</h2>
            <p className="text-gray-700 leading-relaxed">
              Ausführungsfristen sind nur verbindlich, wenn sie ausdrücklich schriftlich zugesichert wurden. Verzögerungen durch höhere Gewalt oder unvorhersehbare Ereignisse verlängern die Frist angemessen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§6 Gewährleistung</h2>
            <p className="text-gray-700 leading-relaxed">
              Es gelten die gesetzlichen Gewährleistungsrechte. Optische Veränderungen durch Trocknung, Feuchtigkeit oder natürliche Materialeigenschaften stellen keinen Mangel dar.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§7 Haftung</h2>
            <p className="text-gray-700 leading-relaxed">
              Wir haften nur für Schäden, die durch Vorsatz oder grobe Fahrlässigkeit verursacht wurden. Für leichte Fahrlässigkeit haften wir nur bei Verletzung wesentlicher Vertragspflichten.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§8 Eigentumsvorbehalt</h2>
            <p className="text-gray-700 leading-relaxed">
              Gelieferte Materialien bleiben bis zur vollständigen Bezahlung unser Eigentum.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§9 Schlussbestimmungen</h2>
            <p className="text-gray-700 leading-relaxed">
              Es gilt das Recht der Bundesrepublik Deutschland.
              Gerichtsstand ist – soweit zulässig – der Sitz der THS Bauprojekte GmbH.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">§10 Salvatorische Klausel</h2>
            <p className="text-gray-700 leading-relaxed">
              Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen unberührt.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};